module.exports = __webpack_public_path__ + "img/icn_landging_efficient.82c47464.svg";